// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/unlink-2.js';

import { paths } from '../generated/unlink-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('unlink-2', Original, paths);
